<template>
    <div class="mainPage">
    <!-- <img src="../img/pakistan/敬请期待_mobile.jpg" alt="" class="coming"> -->
        <div class="header_banner">
            <div class="header">
                <div class="titleCon">
                    <div class="memuCon">
                        <img src="../img/chinesebridge/menu.png" alt="" @click="toggleMenu()">
                        <div class="menu" v-show="activeMenu">
                            <div class="menuUserName" v-if="isLogin">{{user.username}}</div>
                            <div class="logOut" v-if="isLogin" @click="toLogOut()">退出</div>
                            <div class="menuUserName" v-if="!isLogin" @click="toLogin()">登录</div>
                            <div class="logOut" v-if="!isLogin" @click="toLogin()">注册</div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="courseListCon">
            
          <div class="currentInfo">
            <div class="currentCourseTitle">
              <div v-if="currentCourseList.length>0 && (currentCourseList[0].category == 1|| currentCourseList[0].category == 2)" class="title">
                <div >
                  初级班: <span>{{currentCourseList[0].name}}</span>
                </div>
                <div >
                  Beginner Class: <span>{{currentCourseList[0].name_en}}</span>
                </div>
              </div>
              <div v-if="currentCourseList.length>0 && (currentCourseList[0].category == 3|| currentCourseList[0].category == 4)" class="title">
                <div>
                  初级班（儿童）: <span>{{currentCourseList[0].name}}</span>
                </div>
                <div>
                  Beginner Class (For Children): <span>{{currentCourseList[0].name_en}}</span>
                </div>
              </div>
              <div v-if="currentCourseList.length>0 && (currentCourseList[0].category == 5|| currentCourseList[0].category == 6)" class="title">
                <div>
                  中级班  : <span>{{currentCourseList[0].name}}</span>
                </div>
                <div>
                  Intermediate Class: <span>{{currentCourseList[0].name_en}}</span>
                </div>
              </div>
              <div v-if="currentCourseList.length>0 && (currentCourseList[0].category >6)" class="title">
                <div>
                  高级班: <span>{{currentCourseList[0].name}}</span>
                </div>
                <div>
                  Advanced Class: <span>{{currentCourseList[0].name_en}}</span>
                </div>
              </div>
              <div>
                <img src="../img/pakistan/menu.png" alt="" class="courseMenu" @click="isShowCourseMenu = true">
              </div>
            </div>
            <div class="classTypeList" v-show="isShowCourseMenu">
              <img src="../img/pakistan/close.png" alt="" class="close" @click="isShowCourseMenu = false">
              <h2 class="">
                初级班  Beginner Class
              </h2>
              <h3 @click="changeTab(1)" :class="{'active': activeTab == 1}">
                HSK1
              </h3>
              <h3 @click="changeTab(2)" :class="{'active': activeTab == 2}">
                HSK2
              </h3>
              <h2 class="">
                初级班（儿童） 
                <div>
                  Beginner Class (For Children)
                </div>
              </h2>
              <h3 @click="changeTab(3)" :class="{'active': activeTab == 3}">
                YCT1
              </h3>
              <h3 @click="changeTab(4)" :class="{'active': activeTab == 4}">
                YCT2
              </h3>
              <h2 class="">
                中级班  Intermediate Class      
              </h2>
              <h3 @click="changeTab(5)" :class="{'active': activeTab == 5}">
                HSK3
              </h3>
              <h3 @click="changeTab(6)" :class="{'active': activeTab == 6}">
                HSK4（A+B）
              </h3>
              <h2 class="">
                高级班  Advanced Class    
              </h2>
              <h3 @click="changeTab(7)" :class="{'active': activeTab == 7}">
                HSK5（A）
              </h3>
              <h3 @click="changeTab(8)" :class="{'active': activeTab == 8}">
                HSK5（B）
              </h3>
              <h3 @click="changeTab(9)" :class="{'active': activeTab == 9}">
                HSK6（A）
              </h3>
              <h3 @click="changeTab(10)" :class="{'active': activeTab == 10}">
                HSK6（B）
              </h3>
          </div>

          </div>
          <div class="courseList">
            <div class="teacherInfo" v-if="currentCourseList.length>0">
              <div >
                授课教师：<span>{{currentCourseList[0].teacher_name}}</span> <span class="teacherTitle">({{currentCourseList[0].teacher_title}})</span>
              </div>
              <div>
                课程学习时间：<span v-if="currentCourseList[0].category<5">2022年5月28日至8月20日
                </span><span v-if="currentCourseList[0].category>=5">2022年5月25日至8月20日
                </span>
              </div>
              <div>
                <span v-if="currentCourseList[0].category<5">
                北京时间每周六18:00 - 20:15（巴基斯坦时间15:00 - 17:15）
                </span>
                <span v-if="currentCourseList[0].category>=5">
                北京时间每周三、周六18:00 - 20:15（巴基斯坦时间15:00 - 17:15）
                </span>
              </div>
            </div>
            <div class="teacherInfo-en" v-if="currentCourseList.length>0">
              <div v-if="currentCourseList[0].teacher_name_en">
                Instructor: <span>{{currentCourseList[0].teacher_name_en}}</span> <span class="teacherTitle" v-if="currentCourseList[0].teacher_title_en">({{currentCourseList[0].teacher_title_en}})</span>
              </div>
              <div>
                Class Time: 
                <span v-if="currentCourseList[0].category<5">
                From May 28 to August 20, 2022
                </span>
                <span v-if="currentCourseList[0].category>=5">
                From May 25 to August 20, 2022
                </span>
              </div>
              <div>
                <span v-if="currentCourseList[0].category<5">
                  Every Saturday 18:00 - 20:15 Beijing time (15:00 - 17:15 Pakistan time)
                </span>
                <span v-if="currentCourseList[0].category>=5">
                  Every Wednesday and Saturday 18:00 - 20:15 Beijing time (15:00 - 17:15 Pakistan time)
                </span>
                  
                </div>
            </div>
            <div class="line"></div>
            <div class="following-dates">
              具体日期 <span>Schedule</span>
            </div>
            <div class="eg">
              <img src="../img/pakistan/soon.png" alt="">
              <img src="../img/pakistan/current.png" alt="">
              <img src="../img/pakistan/completed.png" alt="">
              <!-- <div class="soon">
                <span></span>
                <span>
                  即将直播  Live soon
                </span>
              </div>
              <div class="current">
                <span></span>
                <span>
                  当前直播  Current Live
                </span>
              </div>
              <div class="completed">
                <span></span>
                <span>
                  已结束  Completed
                </span>
              </div> -->
            </div>
            <ul>
            <li v-for="(item, index) in currentCourseList" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}">
              <div class="coming" v-if="item.customStatus == 0">
                <div class="num">
                  {{index+1}}
                </div>
                <span class="date">
                  {{item.customDate}}
                </span>
                <!-- <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1"> -->
              </div>
              <div class="live" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                <div class="num">
                  {{index+1}}
                </div>
                <span class="date">
                  {{item.customDate}}
                </span>
                <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1">
              </div>
              <!-- <div class="live" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                <div class="num">
                  {{index+1}}
                </div>
                <span class="date">
                  {{item.customDate}}
                </span>
                <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1">
              </div> -->
              <div class="finished" v-if="item.customStatus == 2" @click="replay(item.video_url, item.status, item.id)">
                <div class="num">
                  {{index+1}}
                </div>
                <span class="date">
                  {{item.customDate}}
                  <div class="viewCount">
                    <div>
                      <img src="../img/pakistan/live.svg" alt="" class="icon live">
                      {{item.room_count}}
                    </div>
                    <div>
                      <img src="../img/pakistan/eye.svg" alt="" class="icon eye">
                      {{item.lesson_count}}
                    </div>
                  </div>
                </span>
                <!-- <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1"> -->
              </div>


              <!-- <div class="titleCon">
                  <div class="liveBtn">
                      <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                          <span class="En">
                              Join
                          </span>
                          <span class="Cn">
                              加入
                          </span>
                      </span>
                      <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url)">
                          <span class="En">
                              Replay
                          </span>
                          <span class="Cn">
                              课程回放
                          </span>
                      </span>
                      <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                          直播未开始 Coming Soon
                      </span>
                      <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                          <span class="En">
                              Enter
                          </span>
                          <span class="Cn">
                              进入
                          </span>
                      </span>
                  </div>
              </div> -->
          </li>
        </ul>
          </div>
          <img src="../img/pakistan/m_footer.png" alt="" class="footer">
        </div>
        
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'

export default {
    name: 'chinesebridge',
    components: {
      
    },
    data: function () {
        return {
            isShowCourseMenu: false,
            showMemu: false,
            activeMenu: false,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            isShowGuide: true,
            subject_info: {},
            courseList: [],
            currentCourseList: [],
            activeTab: 1,
            subject_id: null,
            beforeTime: 60, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    computed: {
        language () {
            return this.$i18n.locale
        }
    },
    methods: {
        changePage(page, url) {
            // this.currentMenu = page
            if(url) {
                window.open(url); 
            }
        },
        changeTab(tab) {
            this.activeTab = tab
            this.currentCourseList = []
            this.courseList.forEach(e => {
              if(tab == e.category) {
                this.currentCourseList.push(e)
              }
            })
            this.isShowCourseMenu = false
        },
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                // this.getCourseInfo(this.subject_id)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlistpk', {
                subject_id: id,
                limit: 400
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        e.customDate = this.getCurrentTime(e.start_time)
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }
                    })
                    // res.data.data.list.push(...res.data.data.list)
                    // res.data.data.list.push(...res.data.data.list)
                    // res.data.data.list.push(...res.data.data.list)
                    // res.data.data.list.push(...res.data.data.list)
                    this.courseList = res.data.data.list
                    this.categoryName()
                    this.changeTab(this.activeTab)
                    console.log(this.courseList)
                    this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        getCurrentTime(time) {
          var date = new Date(time);
          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
          var D = date.getDate() + ' '
          if(D < 10) {
            D = '0'+D
          }
          return M +'-'+ D
        },
        categoryName() {
          this.courseList.forEach(e => {
              if(e.name.indexOf('HSK1') > -1) {
                  e.category = 1
              }else if(e.name.indexOf('HSK2') > -1) {
                  e.category = 2
              }else if(e.name.indexOf('YCT1') > -1) {
                  e.category = 3
              }else if(e.name.indexOf('YCT2') > -1) {
                  e.category = 4
              }else if(e.name.indexOf('HSK3') > -1) {
                  e.category = 5
              }else if(e.name.indexOf('HSK4') > -1) {
                  e.category = 6
              }else if(e.name.indexOf('HSK5（A）') > -1) {
                  e.category = 7
              }else if(e.name.indexOf('HSK5（B）') > -1) {
                  e.category = 8
              }else if(e.name.indexOf('HSK6（A）') > -1) {
                  e.category = 9
              }else if(e.name.indexOf('HSK6（B）') > -1) {
                  e.category = 10
              }
          })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                }
            })
        },
        join(item, index, islive) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "03198325b8b61ccc3413cf7e754febea",
                key: "zyz",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set (this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                    }
                }
            })
        },
        joinToLive(item, index) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            if(!item.isOrder) {
                this.join(item, index, true)
            }else {
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
        },
        // 记录学习记录
        setRecord(id) {
          this.$utils.get('/subject/lesson/setPkCount', {
              lesson_id: id
          })
        },
        replay(url, status ,id) {
          if(status == 3) {
            this.isPlay = true
            this.currentVideoUrl = url
            this.setRecord(id)
          } else {
            this.$message({
              message: "课程回放上传中，请稍后查看",
              type: "warning",
            });
          }
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        toggleMenu() {
            this.activeMenu = !this.activeMenu
        }
    },
    mounted() {
        this.customCheckLogin()
        this.getSubjectInfo('pakistan_class_live')
        let activeTab = this.$route.query.tab
        if(activeTab) {
            this.activeTab = activeTab
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
    .coming {
      width: 100%;
    }
    .header_banner {
        width: 100%;
        height: 4.93rem;
    //     background-image: linear-gradient(0deg, 
		// #ffffff 0%, 
		// #cad9ff 100%), 
    //     linear-gradient(
    //         #6187d6, 
    //         #6187d6);
    //     background-blend-mode: normal, 
		// normal;
        background-image: url(../img/pakistan/m_banner.png);
        background-size: cover;
        position: relative;
        overflow: hidden;
        .bg {
            width: 100%;
            height: 4.93rem;
        }
        .header {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 1; 
            text-align: left;
            .titleCon {
              line-height: 0.4rem;
            }
            .title {
              font-size: 0.38rem;
              color: #fff;
              margin-left: 0.48rem;
            }
            .menuYear {
                position: absolute;
                left: 0.2rem;
                top: 0.18rem;
                font-size: 0.3rem;
                z-index: 5;
                padding: 0.04rem 0.08rem 0.04rem 0.08rem;
                border-radius: 0.1rem;
                color: #fd9c29;
                // font-weight: bold;
                background-color: #fff;
                cursor: pointer;
                .caret {
                    display: inline-block;
                    width: 0;
                    height: 0;
                    margin-bottom: 3px;
                    margin-left: 3px;
                    vertical-align: middle;
                    border-top: 6px dashed;
                    border-top: 6px solid\9;
                    border-right: 6px solid transparent;
                    border-left: 6px solid transparent;
                    opacity: .9;
                }
                .activeCaret {
                    border-top: none;
                    border-bottom: 6px dashed;
                }
                .menuList {
                    position: absolute;
                    width: 100%;
                    top: 0.56rem;
                    font-size: 0.3rem;
                    left: 0;
                    color: #282828;
                    font-weight: normal;
                    background-color: #fff;
                    border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
                    box-shadow: 0 0.02rem 0.12rem 0 rgba(0,0,0,0.2);
                    transition: all linear 0.2s;
                    height: 0;
                    overflow:hidden;
                    span {
                        display: block;
                        padding: 0.1rem 0.08rem 0.1rem 0.08rem;
                        border-bottom: 1px solid #ccc;
                    }
                    .active {
                        color: #fd9c29;
                    }
                }
                .menuActive {
                    height: 1.8rem;
                }
            }
            .languageCon {
              position: absolute;
              right: 0.8rem;
              top: 0.21rem;
              font-size: 0;
              z-index: 5;
            }
            .memuCon {
                position: absolute;
                right: 0.33rem;
                top: 0.21rem;
                font-size: 0;
                z-index: 5;
                img {
                    width: 0.4rem;
                }
                .menu {
                    position: absolute;
                    right: 0;
                    top: 0.55rem;
                    background-color: #fff;
                    width: 100px;
                    border-radius: 0.05rem;
                    padding: 0.1rem 0;
                    font-size: 0.3rem;
                    div {
                        color: #333;
                        text-align: center;
                        line-height: 200%;
                    }
                }
            }
            .right_bg {
              position: absolute;
              right: 0.2rem;
              top: 0;
              bottom: 0;
              margin: auto;
              width: 65%;
              opacity: 0.2;
            }
            .content {
                width: 100%;
                height: 100%;
                position: relative;
                .left {
                    display: inline-block;
                    width: 70%;
                    position: absolute;
                    z-index: 1;
                    top: 50%;
                    left: 10%;
                    transform: translateY(-50%);
                    .camp {
                        width: 64%;
                    }
                    .schoolInfo {
                        .logo {
                            height: 0.83rem;
                            margin-top: 0.23rem;
                        }
                        .name {
                            width: 100%;
                            padding: 0 0.68rem 0 0.5rem;
                            font-size: 0.8rem;
                            line-height: 1.2;
                            box-sizing: border-box;
                            text-align: left;
                            color: #fff;
                            font-weight: bold;
                            margin-top: 0.1rem;
                        }
                        .name_1 {
                          font-size:0.46rem;
                          font-weight: normal;
                        }
                        .name_en {
                            width: 100%;
                            font-size: 0.46rem;
                            padding: 0 0.5rem;
                            box-sizing: border-box;
                            text-align: left;
                            font-family: "DINCond-Medium";
                            color: #fff;
                            margin-top: 0.26rem;
                        }
                    }
                }
                
            }
        }
    }
    .tabCon {
        // width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        height: 0.9rem;
        line-height: 0.9rem;
        background-color:#fff;
        padding: 0 0.4rem;
        box-shadow: 0px 3px 5px 0px
		rgba(0, 0, 0, 0.1);
        white-space: nowrap;
        >div {
            // width: 1200px;
            margin: auto;
        }
        .tabBtn {
            display: inline-block;
            margin-right: 0.25rem;
            font-size: 0.4rem;
            cursor: pointer;
            text-align: left;
            vertical-align: top;
            div:last-child {
                font-size: 0.32rem;
                font-family: "DIN-Regular";
            }
        }
        .tabBtn_1 {
          div:last-child {
                font-size: 0.22rem;
                font-family: "DIN-Regular";
                margin-left: 0.1rem;
            }
        }
        .activeTab {
            position: relative;
            color: #f56821;
            :after {
                position: absolute;
                bottom: 0;
                left:0;
                right: 0;
                margin: auto;
                display:inline-block;
                content: '';
                width: 70%;
                height: 0.1rem;
                background-color: #f56821;
            }
        }
        
    }
    .courseListCon {
        width: calc(100% - 0.9rem);
        font-size: 0.3rem;
        min-height: 19rem;
        padding-bottom: 1.8rem;
        margin: auto;
        background-color:#fff;
        position: relative;
        .footer {
          width: calc(100% + 0.9rem);
          position: absolute;
          bottom: 0;
          left: 0;
          margin-left: -0.45rem;
        }
        .classTypeList {
          position: absolute;
          top: 0;
          width: 100%;
          height: 19rem;
          z-index: 2;
          box-sizing: border-box;
          background-color: #3e6c4c;
          border-style: solid;
          border-width: 0.05rem;
          border-image-source: linear-gradient(0deg, 
            #589a72 0%, 
            #3d6b4b 100%);
          border-image-slice: 1;
          // border-radius: 10px;
          text-align: left;
          padding: 0.76rem 0.94rem;
          .close {
            position: absolute;
            right: 0.45rem;
            top: 0.45rem;
            width: 0.63rem;
          }
          h2 {
            font-family: MicrosoftYaHei;
            font-size: 0.4rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: 0px;
            color: #f1c72f;
            margin-bottom: 0.5rem;
          }
          h3 {
            font-size: 0.4rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: 0px;
            color: #fff;
            margin-bottom: 0.5rem;
          }
        }
        .currentInfo {
          width: 100%;
          position: relative;
          .courseMenu {
            position: absolute;
            right: 0.37rem;
            top: 0.4rem;
            width: 0.9rem;
          }
          .currentCourseTitle {
            width: 100%;
            height: 1.5rem;
            background-color: #457856;
            border-radius: 10px 10px 0px 0px;
            padding: 0.25rem 0.38rem;
            box-sizing: border-box;
            text-align: left;
            div:first-child {
              font-size: 0.4rem;
              font-family: SourceHanSansCN-Regular;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #ffffff;
              margin-bottom: 0.1rem;
            }
            div:last-child {
              font-family: DINCond-Medium;
              font-size: 0.36rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #ffffff;
            }
          }
        }
        .teacherInfo {
          
        }
        .liveClass {
            padding-top: 0.25rem;
            width: 100%;
            text-align: center;
            img {
                width: 2.78rem;
            }
        }
        .courseList {
          background-color: rgba(#fff,0.8);
          border-style: solid;
          border-width: 0.05rem;
          border-image-source: linear-gradient(0deg, 
            #589a72 0%, 
            #3d6b4b 100%);
          border-image-slice: 1;
          padding: 0.39rem 0;
          text-align: left;
          position: relative;
          z-index: 1;
          .teacherInfo {
            margin-left: 0.35rem;
            div:first-child {
              font-size: 0.38rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #282828;
              font-weight: bold;
              .teacherTitle {
                color: #78847c;
                font-size: 0.2rem;
                font-weight: initial;
                margin-left: 0.05rem;
              }
            }
            div:nth-child(2) {
              font-size: 0.38rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #282828;
              font-weight: bold;
              margin-top: 0.1rem;
            }
            div:last-child {
              font-size: 0.38rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #457856;
              font-weight: bold;
              margin-top: 0.1rem;
            }
          }
          .teacherInfo-en {
            margin-left: 0.35rem;
            margin-top: 0.39rem;
            div:first-child {
              font-size: 0.38rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #282828;
              font-weight: bold;
              .teacherTitle {
                display: block;
                color: #78847c;
                font-size: 0.2rem;
                font-weight: initial;
                margin-left: 0.05rem;
                margin-top: 0.03rem;
              }
            }
            div:nth-child(2) {
              font-size: 0.38rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #282828;
              font-weight: bold;
              margin-top: 0.1rem;
            }
            div:last-child {
              font-size: 0.38rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #457856;
              font-weight: bold;
              margin-top: 0.1rem;
            }
          }
          .line {
            width: calc(100% - 0.7rem);
            height: 1px;
	          background-color: #457856;
            margin: 0.35rem 0.35rem 0.64rem;
          }
          .following-dates {
              font-family: SourceHanSansCN-Regular;
              font-size: 0.36rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0px;
              color: #457856;
              text-align: center;
              span {
                font-family: DIN-Medium;
                font-size: 0.36rem;
                font-weight: normal;
                letter-spacing: 0px;
                color: #457856;
              }
            }
            .eg {
              text-align: center;
              margin-top: 0.34rem;
              font-size: 0.24rem;
              img {
                height: 0.27rem;
                margin-right: 0.15rem;
              }
              div {
                display: inline-block;
                margin-right: 0.1rem;
                
                span:first-child {
                  display: inline-block;
                  width: 0.2rem;
                  height: 0.2rem;
                  vertical-align: text-top;
                }
                span:last-child {
                  display: inline-block;
                  transform: scale(0.8);
                  text-align: left;
                }
              }
              .soon {
                span:first-child {
                  background-color: #457856;
                }
              }
              .current {
                span:first-child {
                  background-color: #f1c72f;
                }
              }
              .completed {
                span:first-child {
                  background-color: #93a4aa;
                }
              }
            }
        }
        ul {
          // text-align: left;
          margin-top: 0.56rem;
          padding: 0 0.4rem 0 0.6rem;
          box-sizing: border-box;
          text-align: left;
        }
        li {
          width: calc(50% - 0rem);
          padding-right: 0.4rem;
          // box-sizing: border-box;
          display: inline-block;
          // margin-right: 0.55rem;
          margin-bottom: 0.6rem;
          text-align: left;
          cursor: pointer;
          box-sizing: border-box;
          .num {
            display: inline-block;
            text-align: center;
            width: 0.9rem;
            height: 0.9rem;
            line-height: 0.9rem;
            background-color: #457856;
            border-radius: 0.05rem;
            font-family: DIN-Medium;
            font-size: 0.38rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
            margin-right: 0.1rem;
          }
          .date {
            font-family: DIN-Medium;
            font-size: 0.4rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.5rem;
            letter-spacing: 0px;
            color: #282828;
            display: inline-block;
            vertical-align: top;
          }
          .playIcon {
            float: right;
            width: 0.1rem;
            margin-top: 0.2rem;
          }
          & .live {
            .num {
              background-color: #f1c72f;
              color: #457856;
            }
          }
          .finished .num{
            background-color: #93a4aa;
          }
          .viewCount {
            vertical-align: top;
            font-size: 0.34rem;
            line-height: 0.34rem;
            color:#8da6ac;
            height: 0.4rem;
            div {
              display: inline-block;
              vertical-align: middle;
              font-family: DIN-Light;
              .icon {
                width: 0.36rem;
                vertical-align: text-bottom;
              }
              .live {
                width: 0.32rem;
                vertical-align: sub;
              }
              .eye {
                margin-left: 0.1rem;
              }
            }
          }
          .titleCon {
              .title {
                  color: #fd9c29;
                  display: inline-block;
                  .en {
                      font-size: 24px;
                      font-family: 'Georgia';
                      margin-bottom: 2px;
                      width: 800px;
                      line-height: 1.2;
                  }
                  .cn {
                      font-size: 18px;
                      width: 800px;
                      line-height: 1.2;
                  }
              }
              .liveBtn {
                  float: right;
                  display: inline-block;
                  font-family: 'Georgia';
                  color: #282828;
                  .join {
                      display: inline-block;
                      height: 50px;
                      line-height: 1.2;
                      border-radius: 25px;
                      background-color: #fd9c29;
                      color: #fff;
                      padding: 15px 31px;
                      box-sizing: border-box;
                      cursor: pointer;
                      .En {
                          font-size: 22px;
                          vertical-align: top;
                      }
                      .Cn {
                          font-size: 20px;
                          vertical-align: top;
                      }
                  }
                  .replay {
                      background-color: #4a88da;
                      color: #fff;
                  }
                  .isOrder {
                      color: #999;
                  }
              }
          }
        }
        .list {
            position: relative;
            padding: 0 0.14rem;
            text-align: left;
            margin-top: 0.67rem;
            li {
                margin-left: 0.42rem;
                margin-bottom: 1.1rem;
                position: relative;
                .timeCon {
                    font-size: 0;
                    .time {
                        font-size: 0.28rem;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                        vertical-align: top;
                    }
                    .live {
                        float: right;
                        font-size: 0.21rem;
                        color: #379346;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                    .finished {
                        float: right;
                        font-size: 0.21rem;
                        color: #93a4aa;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                }
                .nameCon {
                    margin-top: 0.26rem;
                    margin-bottom: 0.3rem;
                    font-size: 0.28rem;
                    .name {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #364347;
                    }
                    .name_en {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #5e696d;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                    }
                }
                .titleCon {
                    font-size: 0.25rem;
                    height: 0.6rem;
                    width: 100%;
                    .title {
                        color: #fd9c29;
                        display: inline-block;
                        width: calc(100% - 2.5rem);
                        .en {
                            font-size: 0.25rem;
                            font-family: 'Georgia';
                            margin-bottom: 0.02rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 0.25rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        .join {
                            display: inline-block;
                            height: 0.6rem;
                            line-height: 1.2;
                            border-radius: 0.28rem;
                            background-color: #fd9c29;
                            color: #fff;
                            padding: 0.15rem 0.22rem;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 0.26rem;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 0.24rem;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #4a88da;
                            color: #fff;
                        }
                        .isOrder {
                            color: #999;
                            font-size: 0.24rem;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
            .noMore {
                font-size: 0.25rem;
                margin-left: 0.4rem;
                color: #7ecef4;
                position: relative;
            }
            .noMore:after {
                position: absolute;
                right: 0;
                z-index: 1;
                top: 0.18rem;
                display: inline-block;
                content: '';
                height: 0.03rem;
                width: calc(100% - 2.8rem);
                background-color: #7ecef4;
            }
        }
    }
    .guideModel {
        position: fixed;
        right: 0;bottom: 40px;
        z-index: 5;
        cursor: pointer;
        .close {
            font-size: 28px;
            position: absolute;
            top: 15px;right: 15px;
            color: #fff;
            cursor: pointer;
        }
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 100%;
    }
}

</style>
